import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LocationsList from './locations/LocationsList';
import RegionsList from './regions/RegionsList';
import { TabView } from '../../../components';
import config from '../../../config.json';
import { Text } from 'components/v4';

/*
 * Tab View rendered for the regions and locations page on the Sidebar
 */
const TrunkLocations = () => {
    const dispatch = useDispatch();

    // state access
    const { tab } = useSelector((state) => {
        return { ...state.view };
    });

    // use effect to change tab view using redux
    useEffect(() => {
        if (Number.isInteger(tab)) {
            dispatch({
                type: 'CHANGE_TAB_VIEW',
                payload: {
                    level1: 0,
                    level2: 0,
                },
            });
        }
    }, [dispatch, tab]);
    return (
        <>
            <Text
                sx={{
                    fontSize: '20',
                    fontWeight: '500',
                    marginBottom: '15px',
                }}>
                Regions and Locations
            </Text>
            <TabView
                onChange={(_e, v) => {
                    dispatch({
                        type: 'CHANGE_TAB_VIEW',
                        payload: {
                            level1: v,
                            level2: 0,
                        },
                    });
                }}
                value={tab['level1']}
                tabLabels={config.trunkLocations.tabs}
                contents={[
                    <RegionsList key="Regions" />,
                    <LocationsList key="Locations" />,
                ]}
            />
        </>
    );
};

export default TrunkLocations;
